import { brainGame, brainGameEntry } from "../../system/types/brainGame/brainGame";
import { language } from "../../system/types/project/language";
import { BRAIN_GAME_ACTIONS } from "./types";

export const setBrainGameData = (data?: brainGame) =>  {
    return {
        type: BRAIN_GAME_ACTIONS.setGameData,
        payload: data,
    };
};

export const setActiveEntry = (entry: brainGameEntry) => {
    return {
        type: BRAIN_GAME_ACTIONS.setActiveEntry,
        payload: entry,
    };
};

export const removeActiveEntry = () => {
    return {
        type: BRAIN_GAME_ACTIONS.removeActiveEntry,
    };
};


export const setActiveLanguage = (language: language) => {
    return {
        type: BRAIN_GAME_ACTIONS.setActiveLanguage,
        payload: language,
    };
};
